module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/bg_example-36552bf130b659c87d286fb89e7f36ec.png";